export enum ESnackBarEnum {
  'ERROR_SNACKBAR' = 'error-snackbar',
  'INFO_SNACKBAR' = 'info-snackbar',
}
